import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements OnInit {
  @Output() onNext = new EventEmitter<void>();
  @Output() loaded = new EventEmitter<void>();

  ngOnInit() {
    setTimeout(() => {
      this.loaded.emit();
    }, 100);
  }
}
